export function getCardImage(cardName) {
	switch(cardName) {
		case "A Land Divided":
			return import('./a-land-divided.png')

		case "A New Era":
			return import('./a-new-era.png')

		case "A Night to Remember":
			return import('./a-night-to-remember.png')

		case "Abandoned Imperfect":
			return import('./abandoned-imperfect.png')

		case "Abecean Navigator":
			return import('./abecean-navigator.png')

		case "Abnur Tharn":
			return import('./abnur-tharn.png')

		case "Adoring Fan":
			return import('./adoring-fan.png')

		case "Aela the Huntress":
			return import('./aela-the-huntress.png')

		case "Aela's Huntmate":
			return import('./aela-s-huntmate.png')

		case "Afflicted Alit":
			return import('./afflicted-alit.png')

		case "Ageless Automaton":
			return import('./ageless-automaton.png')

		case "Agent of Mehrunes Dagon":
			return import('./agent-of-mehrunes-dagon.png')

		case "Ahnassi":
			return import('./ahnassi.png')

		case "Alchemy":
			return import('./alchemy.png')

		case "Ald Velothi Assassin":
			return import('./ald-velothi-assassin.png')

		case "Ald'ruhn Arms Master":
			return import('./ald-ruhn-arms-master.png')

		case "Aldmeri Patriot":
			return import('./aldmeri-patriot.png')

		case "Aldmeri Spellwright":
			return import('./aldmeri-spellwright.png')

		case "Aldora the Daring":
			return import('./aldora-the-daring.png')

		case "Alduin":
			return import('./alduin.png')

		case "Alfiq Conjurer":
			return import('./alfiq-conjurer.png')

		case "Alfiq Illusionist":
			return import('./alfiq-illusionist.png')

		case "Alik'r Survivalist":
			return import('./alik-r-survivalist.png')

		case "Allena Benoch":
			return import('./allena-benoch.png')

		case "Almalexia's Disciple":
			return import('./almalexia-s-disciple.png')

		case "Almalexia":
			return import('./almalexia.png')

		case "Alpha Wolf":
			return import('./alpha-wolf.png')

		case "Altar of Despair":
			return import('./altar-of-despair.png')

		case "Altar of Spellmaking":
			return import('./altar-of-spellmaking.png')

		case "Altmer Dragonknight":
			return import('./altmer-dragonknight.png')

		case "Altmer Flameslinger":
			return import('./altmer-flameslinger.png')

		case "Ambitious Hireling":
			return import('./ambitious-hireling.png')

		case "An-Xileel Invader":
			return import('./an-xileel-invader.png')

		case "Ancano":
			return import('./ancano.png')

		case "Ancestor's Battleaxe":
			return import('./ancestor-s-battleaxe.png')

		case "Ancestral Dead":
			return import('./ancestral-dead.png')

		case "Ancient Lookout":
			return import('./ancient-lookout.png')

		case "Angry Grahl":
			return import('./angry-grahl.png')

		case "Apex Predator":
			return import('./apex-predator.png')

		case "Apex Wolf":
			return import('./apex-wolf.png')

		case "Apprentice Necromancer":
			return import('./apprentice-necromancer.png')

		case "Arcanaeum Librarian":
			return import('./arcanaeum-librarian.png')

		case "Arcane Enchanter":
			return import('./arcane-enchanter.png')

		case "Archcanon Saryoni":
			return import('./archcanon-saryoni.png')

		case "Archein Elite":
			return import('./archein-elite.png')

		case "Archein Venomtongue":
			return import('./archein-venomtongue.png')

		case "Archer's Gambit":
			return import('./archer-s-gambit.png')

		case "Arenthia Guerrilla":
			return import('./arenthia-guerrilla.png')

		case "Arenthia Swindler":
			return import('./arenthia-swindler.png')

		case "Arise":
			return import('./arise.png')

		case "Arrest":
			return import('./arrest.png')

		case "Arrow Storm":
			return import('./arrow-storm.png')

		case "Arrow in the Knee":
			return import('./arrow-in-the-knee.png')

		case "Artaeum Savant":
			return import('./artaeum-savant.png')

		case "Ascended Sleeper":
			return import('./ascended-sleeper.png')

		case "Ash Berserker":
			return import('./ash-berserker.png')

		case "Ash Oppressor":
			return import('./ash-oppressor.png')

		case "Ash Piercer":
			return import('./ash-piercer.png')

		case "Ash Servant":
			return import('./ash-servant.png')

		case "Ashlander Punisher":
			return import('./ashlander-punisher.png')

		case "Ashlander Zealot":
			return import('./ashlander-zealot.png')

		case "Aspect of Hircine":
			return import('./aspect-of-hircine.png')

		case "Assassin Beetle":
			return import('./assassin-beetle.png')

		case "Assassin's Bow":
			return import('./assassin-s-bow.png')

		case "Assassin's Ritual":
			return import('./assassin-s-ritual.png')

		case "Assembled Conduit":
			return import('./assembled-conduit.png')

		case "Assembled Sanitizer":
			return import('./assembled-sanitizer.png')

		case "Assembled Sentry":
			return import('./assembled-sentry.png')

		case "Assembled Titan":
			return import('./assembled-titan.png')

		case "Astrid":
			return import('./astrid.png')

		case "Attuned Dremora":
			return import('./attuned-dremora.png')

		case "Aundae Clan Sorcerer":
			return import('./aundae-clan-sorcerer.png')

		case "Auridon Paladin":
			return import('./auridon-paladin.png')

		case "Auroran Sentry":
			return import('./auroran-sentry.png')

		case "Awakened Dreamer":
			return import('./awakened-dreamer.png')

		case "Awakened Imperfect":
			return import('./awakened-imperfect.png')

		case "Ayleid Guardian":
			return import('./ayleid-guardian.png')

		case "Ayrenn's Chosen":
			return import('./ayrenn-s-chosen.png')

		case "Ayrenn, Dominion Queen":
			return import('./ayrenn-dominion-queen.png')

		case "Ayrenn":
			return import('./ayrenn.png')

		case "Baandari Bruiser":
			return import('./baandari-bruiser.png')

		case "Baandari Opportunist":
			return import('./baandari-opportunist.png')

		case "Back-Alley Footpad":
			return import('./back-alley-footpad.png')

		case "Back-Alley Rogue":
			return import('./back-alley-rogue.png')

		case "Bal Isra Warrider":
			return import('./bal-isra-warrider.png')

		case "Baliwog Tidecrawlers/Smoked Baliwog Leg":
			return import('./baliwog-tidecrawlers-smoked-baliwog-leg.png')

		case "Balmora Captain":
			return import('./balmora-captain.png')

		case "Balmora Puppeteer":
			return import('./balmora-puppeteer.png')

		case "Balmora Spymaster":
			return import('./balmora-spymaster.png')

		case "Bandit Ringleader":
			return import('./bandit-ringleader.png')

		case "Bangkorai Butcher":
			return import('./bangkorai-butcher.png')

		case "Barbas":
			return import('./barbas.png')

		case "Barded Guar":
			return import('./barded-guar.png')

		case "Barilzar's Tinkering":
			return import('./barilzar-s-tinkering.png')

		case "Baron of Tear":
			return import('./baron-of-tear.png')

		case "Barrow Stalker":
			return import('./barrow-stalker.png')

		case "Barter":
			return import('./barter.png')

		case "Battle of Chalman Keep":
			return import('./battle-of-chalman-keep.png')

		case "Battlefield Scrounger":
			return import('./battlefield-scrounger.png')

		case "Battlemage's Onslaught":
			return import('./battlemage-s-onslaught.png')

		case "Battlerage Orc":
			return import('./battlerage-orc.png')

		case "Battlereeve of Dusk":
			return import('./battlereeve-of-dusk.png')

		case "Be at Peace":
			return import('./be-at-peace.png')

		case "Bedeviling Scamp":
			return import('./bedeviling-scamp.png')

		case "Bedlam":
			return import('./bedlam.png')

		case "Belligerent Giant":
			return import('./belligerent-giant.png')

		case "Berne Clan Nightstalker":
			return import('./berne-clan-nightstalker.png')

		case "Berserker of the Pale":
			return import('./berserker-of-the-pale.png')

		case "Betty Netch":
			return import('./betty-netch.png')

		case "Bewildering Speed":
			return import('./bewildering-speed.png')

		case "Bishop of the Hour":
			return import('./bishop-of-the-hour.png')

		case "Bitterfish Witch":
			return import('./bitterfish-witch.png')

		case "Black Hand Messenger":
			return import('./black-hand-messenger.png')

		case "Black Marsh Centurion":
			return import('./black-marsh-centurion.png')

		case "Black Marsh Prodigy":
			return import('./black-marsh-prodigy.png')

		case "Black Marsh Warden":
			return import('./black-marsh-warden.png')

		case "Black Soul Gem":
			return import('./black-soul-gem.png')

		case "Black Worm Necromancer":
			return import('./black-worm-necromancer.png')

		case "Black Worm Neophyte":
			return import('./black-worm-neophyte.png')

		case "Blackmail":
			return import('./blackmail.png')

		case "Blackreach Rebuilder":
			return import('./blackreach-rebuilder.png')

		case "Blackrose Herbalist":
			return import('./blackrose-herbalist.png')

		case "Blacksap Protector":
			return import('./blacksap-protector.png')

		case "Blackwood Alchemist":
			return import('./blackwood-alchemist.png')

		case "Blackwood Distiller":
			return import('./blackwood-distiller.png')

		case "Blades Defender":
			return import('./blades-defender.png')

		case "Blades Flanker":
			return import('./blades-flanker.png')

		case "Blades Guardian":
			return import('./blades-guardian.png')

		case "Blades Lookout":
			return import('./blades-lookout.png')

		case "Blades Stalwart":
			return import('./blades-stalwart.png')

		case "Blast from Oblivion":
			return import('./blast-from-oblivion.png')

		case "Blastbones":
			return import('./blastbones.png')

		case "Bleakcoast Troll":
			return import('./bleakcoast-troll.png')

		case "Blessing of the Grove":
			return import('./blessing-of-the-grove.png')

		case "Blighted Alit":
			return import('./blighted-alit.png')

		case "Blighted Werebat":
			return import('./blighted-werebat.png')

		case "Blind Moth Priest":
			return import('./blind-moth-priest.png')

		case "Blood Dragon":
			return import('./blood-dragon.png')

		case "Blood Magic Lord":
			return import('./blood-magic-lord.png')

		case "Blood Pact Messenger":
			return import('./blood-pact-messenger.png')

		case "Blood Sacrament":
			return import('./blood-sacrament.png')

		case "Blood Sorceress":
			return import('./blood-sorceress.png')

		case "Blood-Crazed Daedroth":
			return import('./blood-crazed-daedroth.png')

		case "Bloodline Outcast":
			return import('./bloodline-outcast.png')

		case "Bloody Hand Chef":
			return import('./bloody-hand-chef.png')

		case "Blueclaw Matron":
			return import('./blueclaw-matron.png')

		case "Bog Lurcher":
			return import('./bog-lurcher.png')

		case "Bolvyn Venim":
			return import('./bolvyn-venim.png')

		case "Bone Armor":
			return import('./bone-armor.png')

		case "Bone Bow":
			return import('./bone-bow.png')

		case "Bone Colossus":
			return import('./bone-colossus.png')

		case "Bonewalker":
			return import('./bonewalker.png')

		case "Boneweaver":
			return import('./boneweaver.png')

		case "Brass Arquebus":
			return import('./brass-arquebus.png')

		case "Brassilisk":
			return import('./brassilisk.png')

		case "Brellach Commander":
			return import('./brellach-commander.png')

		case "Breton Conjurer":
			return import('./breton-conjurer.png')

		case "Brilliant Experiment":
			return import('./brilliant-experiment.png')

		case "Bringer of Nightmares":
			return import('./bringer-of-nightmares.png')

		case "Brotherhood Sanctuary":
			return import('./brotherhood-sanctuary.png')

		case "Brotherhood Slayer":
			return import('./brotherhood-slayer.png')

		case "Brotherhood Suspect":
			return import('./brotherhood-suspect.png')

		case "Brotherhood Vampire":
			return import('./brotherhood-vampire.png')

		case "Bruma Armorer":
			return import('./bruma-armorer.png')

		case "Bruma Oppressor":
			return import('./bruma-oppressor.png')

		case "Bruma Profiteer":
			return import('./bruma-profiteer.png')

		case "Brutal Ashlander":
			return import('./brutal-ashlander.png')

		case "Brynjolf":
			return import('./brynjolf.png')

		case "Burn and Pillage":
			return import('./burn-and-pillage.png')

		case "Burning Touch":
			return import('./burning-touch.png')

		case "Bushwhack":
			return import('./bushwhack.png')

		case "Cadwell the Soul Shriven/Cadwell the Betrayer":
			return import('./cadwell-the-soul-shriven-cadwell-the-betrayer.png')

		case "Caius Cosades":
			return import('./caius-cosades.png')

		case "Caius' Machinations":
			return import('./caius-machinations.png')

		case "Call Dragon":
			return import('./call-dragon.png')

		case "Call of Valor":
			return import('./call-of-valor.png')

		case "Calm":
			return import('./calm.png')

		case "Camlorn Hero":
			return import('./camlorn-hero.png')

		case "Camlorn Sentinel":
			return import('./camlorn-sentinel.png')

		case "Camonna Tong Heavy":
			return import('./camonna-tong-heavy.png')

		case "Camoran Scout Leader":
			return import('./camoran-scout-leader.png')

		case "Candlehearth Brawler":
			return import('./candlehearth-brawler.png')

		case "Caravan Enforcer":
			return import('./caravan-enforcer.png')

		case "Cartel Arcanist":
			return import('./cartel-arcanist.png')

		case "Cartel Bruiser":
			return import('./cartel-bruiser.png')

		case "Cast Into Time":
			return import('./cast-into-time.png')

		case "Cast Out":
			return import('./cast-out.png')

		case "Cathay-raht Veteran":
			return import('./cathay-raht-veteran.png')

		case "Cauldron Keeper":
			return import('./cauldron-keeper.png')

		case "Cauterize":
			return import('./cauterize.png')

		case "Cave Bear":
			return import('./cave-bear.png')

		case "Champion of the Arena":
			return import('./champion-of-the-arena.png')

		case "Channeled Storm":
			return import('./channeled-storm.png')

		case "Chanter of Akatosh":
			return import('./chanter-of-akatosh.png')

		case "Chaurus Breeding Pit":
			return import('./chaurus-breeding-pit.png')

		case "Chaurus Reaper":
			return import('./chaurus-reaper.png')

		case "Chaurus":
			return import('./chaurus.png')

		case "Cheesemancer":
			return import('./cheesemancer.png')

		case "Cheydinhal Sapper":
			return import('./cheydinhal-sapper.png')

		case "Chieftain's Banner":
			return import('./chieftain-s-banner.png')

		case "Child of Hircine":
			return import('./child-of-hircine.png')

		case "Chodala's Treachery":
			return import('./chodala-s-treachery.png')

		case "Cicero the Betrayer":
			return import('./cicero-the-betrayer.png')

		case "Circle Initiate":
			return import('./circle-initiate.png')

		case "City Guard":
			return import('./city-guard.png')

		case "Clannfear Runt":
			return import('./clannfear-runt.png')

		case "Cleric of Kyne":
			return import('./cleric-of-kyne.png')

		case "Cliff Hunter":
			return import('./cliff-hunter.png')

		case "Cliff Racer Onslaught":
			return import('./cliff-racer-onslaught.png')

		case "Cliff Racer":
			return import('./cliff-racer.png')

		case "Cliff Strider":
			return import('./cliff-strider.png')

		case "Cliffside Lookout":
			return import('./cliffside-lookout.png')

		case "Clivia Tharn":
			return import('./clivia-tharn.png')

		case "Cloak/Dagger":
			return import('./cloak-dagger.png')

		case "Clockwork Apostle":
			return import('./clockwork-apostle.png')

		case "Clockwork City Pilgrim":
			return import('./clockwork-city-pilgrim.png')

		case "Clockwork Dragon":
			return import('./clockwork-dragon.png')

		case "Clockwork Scorpion":
			return import('./clockwork-scorpion.png')

		case "Close Call":
			return import('./close-call.png')

		case "Cloudrest Illusionist":
			return import('./cloudrest-illusionist.png')

		case "Cog Collector":
			return import('./cog-collector.png')

		case "College of Winterhold":
			return import('./college-of-winterhold.png')

		case "Companion Harbinger":
			return import('./companion-harbinger.png')

		case "Conjuration Scholar":
			return import('./conjuration-scholar.png')

		case "Conjuration Tutor":
			return import('./conjuration-tutor.png')

		case "Conjurer's Spirit":
			return import('./conjurer-s-spirit.png')

		case "Corinthe Brawler":
			return import('./corinthe-brawler.png')

		case "Cornerclub Gambler":
			return import('./cornerclub-gambler.png')

		case "Corprus Disease":
			return import('./corprus-disease.png')

		case "Corrupted Shade":
			return import('./corrupted-shade.png')

		case "Corsair Ship":
			return import('./corsair-ship.png')

		case "Court Wizard":
			return import('./court-wizard.png')

		case "Covenant Mail":
			return import('./covenant-mail.png')

		case "Covenant Marauder":
			return import('./covenant-marauder.png')

		case "Covenant Masterpiece":
			return import('./covenant-masterpiece.png')

		case "Covenant Oathman":
			return import('./covenant-oathman.png')

		case "Covenant Plate":
			return import('./covenant-plate.png')

		case "Cradlecrush Giant":
			return import('./cradlecrush-giant.png')

		case "Craglorn Scavenger":
			return import('./craglorn-scavenger.png')

		case "Crassius' Favor":
			return import('./crassius-favor.png')

		case "Craven Conscript":
			return import('./craven-conscript.png')

		case "Crazed Hunger":
			return import('./crazed-hunger.png')

		case "Crocodile Brute":
			return import('./crocodile-brute.png')

		case "Crown Quartermaster":
			return import('./crown-quartermaster.png')

		case "Crucible Blacksmith":
			return import('./crucible-blacksmith.png')

		case "Cruel Axe":
			return import('./cruel-axe.png')

		case "Cruel Firebloom":
			return import('./cruel-firebloom.png')

		case "Crusader's Assault":
			return import('./crusader-s-assault.png')

		case "Crushing Blow":
			return import('./crushing-blow.png')

		case "Crystal Tower Crafter":
			return import('./crystal-tower-crafter.png')

		case "Cunning Ally":
			return import('./cunning-ally.png')

		case "Curse":
			return import('./curse.png')

		case "Cursed Spectre":
			return import('./cursed-spectre.png')

		case "Cygnus Standard Bearer":
			return import('./cygnus-standard-bearer.png')

		case "Cyriel":
			return import('./cyriel.png')

		case "Daedric Crescent":
			return import('./daedric-crescent.png')

		case "Daedric Dagger":
			return import('./daedric-dagger.png')

		case "Daedric Incursion":
			return import('./daedric-incursion.png')

		case "Daedric Titan":
			return import('./daedric-titan.png')

		case "Daggerfall Mage":
			return import('./daggerfall-mage.png')

		case "Daggerfall Phantom":
			return import('./daggerfall-phantom.png')

		case "Daggers in the Dark":
			return import('./daggers-in-the-dark.png')

		case "Dagi-raht Mystic":
			return import('./dagi-raht-mystic.png')

		case "Dagoth Dagger":
			return import('./dagoth-dagger.png')

		case "Dagoth Oathman":
			return import('./dagoth-oathman.png')

		case "Dagoth Ur":
			return import('./dagoth-ur.png')

		case "Daring Cutpurse":
			return import('./daring-cutpurse.png')

		case "Daring Heist":
			return import('./daring-heist.png')

		case "Dark Anchor":
			return import('./dark-anchor.png')

		case "Dark Guardian":
			return import('./dark-guardian.png')

		case "Dark Harvester":
			return import('./dark-harvester.png')

		case "Dark Mane":
			return import('./dark-mane.png')

		case "Dark Rebirth":
			return import('./dark-rebirth.png')

		case "Dark Rift":
			return import('./dark-rift.png')

		case "Dark Seducer":
			return import('./dark-seducer.png')

		case "Dawn's Wrath":
			return import('./dawn-s-wrath.png')

		case "Dawnbreaker":
			return import('./dawnbreaker.png')

		case "Dawnfang":
			return import('./dawnfang.png')

		case "Dawnstar Healer":
			return import('./dawnstar-healer.png')

		case "Dead Drop":
			return import('./dead-drop.png')

		case "Deadly Draugr":
			return import('./deadly-draugr.png')

		case "Death Hound":
			return import('./death-hound.png')

		case "Death Scythe":
			return import('./death-scythe.png')

		case "Deathless Draugr":
			return import('./deathless-draugr.png')

		case "Debilitate":
			return import('./debilitate.png')

		case "Deepwood Trapper":
			return import('./deepwood-trapper.png')

		case "Defense of Bruma":
			return import('./defense-of-bruma.png')

		case "Deranged Corprus":
			return import('./deranged-corprus.png')

		case "Descendant of Alkosh":
			return import('./descendant-of-alkosh.png')

		case "Deshaan Avenger":
			return import('./deshaan-avenger.png')

		case "Desperate Conjuring":
			return import('./desperate-conjuring.png')

		case "Destruction Tutor":
			return import('./destruction-tutor.png')

		case "Determined Supplier":
			return import('./determined-supplier.png')

		case "Devious Bandit":
			return import('./devious-bandit.png')

		case "Devour":
			return import('./devour.png')

		case "Devouring Flame":
			return import('./devouring-flame.png')

		case "Discerning Thief":
			return import('./discerning-thief.png')

		case "Disciple of Namira":
			return import('./disciple-of-namira.png')

		case "Dismantle":
			return import('./dismantle.png')

		case "Divayth Fyr":
			return import('./divayth-fyr.png')

		case "Divayth's Experiments":
			return import('./divayth-s-experiments.png')

		case "Dive Rock Fall":
			return import('./dive-rock-fall.png')

		case "Divine Fervor":
			return import('./divine-fervor.png')

		case "Dominion Battlereeve":
			return import('./dominion-battlereeve.png')

		case "Dominion Oathman":
			return import('./dominion-oathman.png')

		case "Doomcrag Vampire":
			return import('./doomcrag-vampire.png')

		case "Doomed Adventurer":
			return import('./doomed-adventurer.png')

		case "Doomfang Ally":
			return import('./doomfang-ally.png')

		case "Doppelganger":
			return import('./doppelganger.png')

		case "Dormant Centurion":
			return import('./dormant-centurion.png')

		case "Dovah of the Voice":
			return import('./dovah-of-the-voice.png')

		case "Dragonfire Wizard":
			return import('./dragonfire-wizard.png')

		case "Dragon Aspect":
			return import('./dragon-aspect.png')

		case "Dragon Cult Ghost":
			return import('./dragon-cult-ghost.png')

		case "Dragon Mound":
			return import('./dragon-mound.png')

		case "Dragon Priest Mask":
			return import('./dragon-priest-mask.png')

		case "Dragon's Fury":
			return import('./dragon-s-fury.png')

		case "Dragonguard Outcast":
			return import('./dragonguard-outcast.png')

		case "Dragonplate Armor":
			return import('./dragonplate-armor.png')

		case "Dragonstar Rider":
			return import('./dragonstar-rider.png')

		case "Dragontail Savior":
			return import('./dragontail-savior.png')

		case "Drain Blood":
			return import('./drain-blood.png')

		case "Drain Vitality":
			return import('./drain-vitality.png')

		case "Dread Clannfear":
			return import('./dread-clannfear.png')

		case "Dremora Adept":
			return import('./dremora-adept.png')

		case "Dremora Archer":
			return import('./dremora-archer.png')

		case "Dremora Channeler":
			return import('./dremora-channeler.png')

		case "Dremora Markynaz":
			return import('./dremora-markynaz.png')

		case "Dren Bodyguard":
			return import('./dren-bodyguard.png')

		case "Dres Renegade":
			return import('./dres-renegade.png')

		case "Dres Spy":
			return import('./dres-spy.png')

		case "Dres Tormentor":
			return import('./dres-tormentor.png')

		case "Dreugh Shell Armor":
			return import('./dreugh-shell-armor.png')

		case "Drive Mad":
			return import('./drive-mad.png')

		case "Dro-m'Athra Reaper":
			return import('./dro-m-athra-reaper.png')

		case "Duel Atop the World":
			return import('./duel-atop-the-world.png')

		case "Duke Vedam Dren":
			return import('./duke-vedam-dren.png')

		case "Duneripper":
			return import('./duneripper.png')

		case "Dune Smuggler":
			return import('./dune-smuggler.png')

		case "Dune Stalker":
			return import('./dune-stalker.png')

		case "Dunmer Nightblade":
			return import('./dunmer-nightblade.png')

		case "Dunmer Tyro":
			return import('./dunmer-tyro.png')

		case "Dushnikh Yal Archer":
			return import('./dushnikh-yal-archer.png')

		case "Dust Eater Skirmisher":
			return import('./dust-eater-skirmisher.png')

		case "Dwarven Armaments":
			return import('./dwarven-armaments.png')

		case "Dwarven Ballista":
			return import('./dwarven-ballista.png')

		case "Dwarven Centurion":
			return import('./dwarven-centurion.png')

		case "Dwarven Colossus":
			return import('./dwarven-colossus.png')

		case "Dwarven Dynamo":
			return import('./dwarven-dynamo.png')

		case "Dwarven Sphere":
			return import('./dwarven-sphere.png')

		case "Dwarven Spider":
			return import('./dwarven-spider.png')

		case "Dwemer Puzzle Box":
			return import('./dwemer-puzzle-box.png')

		case "Eager Torturer":
			return import('./eager-torturer.png')

		case "Earthbone Spinner":
			return import('./earthbone-spinner.png')

		case "East Empire Crafter":
			return import('./east-empire-crafter.png')

		case "Eastmarch Crusader":
			return import('./eastmarch-crusader.png')

		case "Ebonheart Oracle":
			return import('./ebonheart-oracle.png')

		case "Ebonthread Cloak":
			return import('./ebonthread-cloak.png')

		case "Echo of Akatosh":
			return import('./echo-of-akatosh.png')

		case "Eclipse Baroness":
			return import('./eclipse-baroness.png')

		case "Edict of Azura":
			return import('./edict-of-azura.png')

		case "Elder Centaur":
			return import('./elder-centaur.png')

		case "Eldergleam Matron":
			return import('./eldergleam-matron.png')

		case "Elixir of Conflict":
			return import('./elixir-of-conflict.png')

		case "Elixir of Deflection":
			return import('./elixir-of-deflection.png')

		case "Elixir of Light Feet":
			return import('./elixir-of-light-feet.png')

		case "Elixir of Potency":
			return import('./elixir-of-potency.png')

		case "Elixir of Vigor":
			return import('./elixir-of-vigor.png')

		case "Elixir of Vitality":
			return import('./elixir-of-vitality.png')

		case "Elixir of the Defender":
			return import('./elixir-of-the-defender.png')

		case "Elsweyr Lookout":
			return import('./elsweyr-lookout.png')

		case "Elusive Schemer":
			return import('./elusive-schemer.png')

		case "Embassy Disguise":
			return import('./embassy-disguise.png')

		case "Embassy Guard":
			return import('./embassy-guard.png')

		case "Emeric's Warlord":
			return import('./emeric-s-warlord.png')

		case "Emeric, Covenant King":
			return import('./emeric-covenant-king.png')

		case "Emperor Titus Mede II":
			return import('./emperor-titus-mede-ii.png')

		case "Emperor's Attendant":
			return import('./emperor-s-attendant.png')

		case "Emperor's Blade":
			return import('./emperor-s-blade.png')

		case "Empire Dreadmage":
			return import('./empire-dreadmage.png')

		case "Empire Oathman":
			return import('./empire-oathman.png')

		case "Empire Recruiter":
			return import('./empire-recruiter.png')

		case "Enamor's Keeper":
			return import('./enamor-s-keeper.png')

		case "Enchanted Plate":
			return import('./enchanted-plate.png')

		case "Enchanted Ring":
			return import('./enchanted-ring.png')

		case "Encumbered Explorer":
			return import('./encumbered-explorer.png')

		case "Enlistment Officer":
			return import('./enlistment-officer.png')

		case "Enraged Dragonknight":
			return import('./enraged-dragonknight.png')

		case "Enraged Mudcrab":
			return import('./enraged-mudcrab.png')

		case "Euraxia Tharn":
			return import('./euraxia-tharn.png')

		case "Euraxian Berserker":
			return import('./euraxian-berserker.png')

		case "Evermore Steward":
			return import('./evermore-steward.png')

		case "Excavate":
			return import('./excavate.png')

		case "Execute":
			return import('./execute.png')

		case "Explore":
			return import('./explore.png')

		case "Expunge":
			return import('./expunge.png')

		case "Fabricate":
			return import('./fabricate.png')

		case "Faded Wraith":
			return import('./faded-wraith.png')

		case "Falinesti Reaver":
			return import('./falinesti-reaver.png')

		case "Falkreath Defiler":
			return import('./falkreath-defiler.png')

		case "Fallen Dragon":
			return import('./fallen-dragon.png')

		case "Falling Wizard":
			return import('./falling-wizard.png')

		case "False Incarnate":
			return import('./false-incarnate.png')

		case "Farsight Nereid":
			return import('./farsight-nereid.png')

		case "Fate Weaver":
			return import('./fate-weaver.png')

		case "Fear Totem":
			return import('./fear-totem.png')

		case "Fearless Northlander":
			return import('./fearless-northlander.png')

		case "Feasting Hunger":
			return import('./feasting-hunger.png')

		case "Feasting Vulture":
			return import('./feasting-vulture.png')

		case "Feed":
			return import('./feed.png')

		case "Fell the Mighty":
			return import('./fell-the-mighty.png')

		case "Felldew/Elytra Noble":
			return import('./felldew-elytra-noble.png')

		case "Ferocious Dreugh":
			return import('./ferocious-dreugh.png')

		case "Fetcherfly Golem":
			return import('./fetcherfly-golem.png')

		case "Fharun Defender":
			return import('./fharun-defender.png')

		case "Fiery Imp":
			return import('./fiery-imp.png')

		case "Fifth Legion Trainer":
			return import('./fifth-legion-trainer.png')

		case "Fighters Guild Berserker":
			return import('./fighters-guild-berserker.png')

		case "Fighters Guild Elite":
			return import('./fighters-guild-elite.png')

		case "Fighters Guild Hall":
			return import('./fighters-guild-hall.png')

		case "Fighters Guild Recruit":
			return import('./fighters-guild-recruit.png')

		case "Fighters Guild Steward":
			return import('./fighters-guild-steward.png')

		case "Fingers of the Mountain":
			return import('./fingers-of-the-mountain.png')

		case "Finish Off":
			return import('./finish-off.png')

		case "Fire Breath":
			return import('./fire-breath.png')

		case "Fire Storm":
			return import('./fire-storm.png')

		case "Fireball":
			return import('./fireball.png')

		case "Firebolt":
			return import('./firebolt.png')

		case "Firepot Spider":
			return import('./firepot-spider.png')

		case "Flamespear Dragon":
			return import('./flamespear-dragon.png')

		case "Flaming Breath":
			return import('./flaming-breath.png')

		case "Fleeting Apparition":
			return import('./fleeting-apparition.png')

		case "Flesh Atronach":
			return import('./flesh-atronach.png')

		case "Flesh Sculpture":
			return import('./flesh-sculpture.png')

		case "Forces of Destruction":
			return import('./forces-of-destruction.png')

		case "Forerunner of the Pact":
			return import('./forerunner-of-the-pact.png')

		case "Fork of Horripilation":
			return import('./fork-of-horripilation.png')

		case "Forked Bolt":
			return import('./forked-bolt.png')

		case "Forsaken Champion":
			return import('./forsaken-champion.png')

		case "Forsworn Guide":
			return import('./forsworn-guide.png')

		case "Forsworn Looter":
			return import('./forsworn-looter.png')

		case "Fortress Guard":
			return import('./fortress-guard.png')

		case "Fortress Watchman":
			return import('./fortress-watchman.png')

		case "Forward Camp":
			return import('./forward-camp.png')

		case "Frazzled Alfiq":
			return import('./frazzled-alfiq.png')

		case "Frenzied Alit":
			return import('./frenzied-alit.png')

		case "Frenzied Witchman":
			return import('./frenzied-witchman.png')

		case "Fresh Start":
			return import('./fresh-start.png')

		case "Frost Giant":
			return import('./frost-giant.png')

		case "Frost Troll":
			return import('./frost-troll.png')

		case "Frostbite Spider":
			return import('./frostbite-spider.png')

		case "Frostscale Dragon":
			return import('./frostscale-dragon.png')

		case "Galyn the Shelterer":
			return import('./galyn-the-shelterer.png')

		case "Gardener of Swords":
			return import('./gardener-of-swords.png')

		case "Gardener's Harvest":
			return import('./gardener-s-harvest.png')

		case "Garnag, Dark Adherent":
			return import('./garnag-dark-adherent.png')

		case "Gates of Madness":
			return import('./gates-of-madness.png')

		case "Gavel of the Ordinator":
			return import('./gavel-of-the-ordinator.png')

		case "Gearwork Spider":
			return import('./gearwork-spider.png')

		case "General Tullius":
			return import('./general-tullius.png')

		case "Genius Pathmage":
			return import('./genius-pathmage.png')

		case "Gentleman Jim Stacey":
			return import('./gentleman-jim-stacey.png')

		case "Ghost Fanatic":
			return import('./ghost-fanatic.png')

		case "Ghost Sea Lookout":
			return import('./ghost-sea-lookout.png')

		case "Ghostgate Defender":
			return import('./ghostgate-defender.png')

		case "Giant Bat":
			return import('./giant-bat.png')

		case "Giant Chicken":
			return import('./giant-chicken.png')

		case "Giant Slaughterfish":
			return import('./giant-slaughterfish.png')

		case "Giant Snake":
			return import('./giant-snake.png')

		case "Giant's Camp":
			return import('./giant-s-camp.png')

		case "Glacial Dragon":
			return import('./glacial-dragon.png')

		case "Gladiator Arena":
			return import('./gladiator-arena.png')

		case "Glass Greaves":
			return import('./glass-greaves.png')

		case "Glass Helm of Remedy":
			return import('./glass-helm-of-remedy.png')

		case "Glenumbra Sorceress":
			return import('./glenumbra-sorceress.png')

		case "Gloom Wraith":
			return import('./gloom-wraith.png')

		case "Gloomlurker":
			return import('./gloomlurker.png')

		case "Gnarl Rootbender":
			return import('./gnarl-rootbender.png')

		case "Goblin Skulk":
			return import('./goblin-skulk.png')

		case "Goldbrand":
			return import('./goldbrand.png')

		case "Golden Initiate":
			return import('./golden-initiate.png')

		case "Golden Saint":
			return import('./golden-saint.png')

		case "Gortwog gro-Nagorm":
			return import('./gortwog-gro-nagorm.png')

		case "Goutfang Adept":
			return import('./goutfang-adept.png')

		case "Grahtwood Ambusher":
			return import('./grahtwood-ambusher.png')

		case "Grand Ball":
			return import('./grand-ball.png')

		case "Grand Inquisitor":
			return import('./grand-inquisitor.png')

		case "Grappling Hook":
			return import('./grappling-hook.png')

		case "Grave Grasp":
			return import('./grave-grasp.png')

		case "Gravesinger":
			return import('./gravesinger.png')

		case "Gray Viper Brigand":
			return import('./gray-viper-brigand.png')

		case "Graystone Ravager":
			return import('./graystone-ravager.png')

		case "Great Moot Squire":
			return import('./great-moot-squire.png')

		case "Great Sigil Stone":
			return import('./great-sigil-stone.png')

		case "Greatwood Elder":
			return import('./greatwood-elder.png')

		case "Green Pact Ambusher":
			return import('./green-pact-ambusher.png')

		case "Green Pact Stalker":
			return import('./green-pact-stalker.png')

		case "Green-Touched Spriggan":
			return import('./green-touched-spriggan.png')

		case "Greenheart Knight":
			return import('./greenheart-knight.png')

		case "Greybeard Mentor":
			return import('./greybeard-mentor.png')

		case "Grim Champion":
			return import('./grim-champion.png')

		case "Grim Shield-Brother":
			return import('./grim-shield-brother.png')

		case "Grisly Gourmet":
			return import('./grisly-gourmet.png')

		case "Gristlehide Dreugh":
			return import('./gristlehide-dreugh.png')

		case "Grummite Magus":
			return import('./grummite-magus.png')

		case "Guar Stablemaster":
			return import('./guar-stablemaster.png')

		case "Guildsworn Apprentice":
			return import('./guildsworn-apprentice.png')

		case "Guildsworn Bloodluster":
			return import('./guildsworn-bloodluster.png')

		case "Guildsworn Cavalier":
			return import('./guildsworn-cavalier.png')

		case "Guildsworn Honeytongue":
			return import('./guildsworn-honeytongue.png')

		case "Guildsworn Incendiary":
			return import('./guildsworn-incendiary.png')

		case "Guildsworn Oathman":
			return import('./guildsworn-oathman.png')

		case "Guildsworn Revitalizer":
			return import('./guildsworn-revitalizer.png')

		case "Guildsworn Wayfarer":
			return import('./guildsworn-wayfarer.png')

		case "Haafingar Marauder":
			return import('./haafingar-marauder.png')

		case "Hackwing Feather":
			return import('./hackwing-feather.png')

		case "Hallowed Deathpriest":
			return import('./hallowed-deathpriest.png')

		case "Halls of the Dwemer":
			return import('./halls-of-the-dwemer.png')

		case "Hand of Dagoth":
			return import('./hand-of-dagoth.png')

		case "Hannibal Traven":
			return import('./hannibal-traven.png')

		case "Harmony":
			return import('./harmony.png')

		case "Haskill":
			return import('./haskill.png')

		case "Hatchery Meddler":
			return import('./hatchery-meddler.png')

		case "Haunted Manor":
			return import('./haunted-manor.png')

		case "Haunting Spirit":
			return import('./haunting-spirit.png')

		case "Headless Zombie":
			return import('./headless-zombie.png')

		case "Healing Hands":
			return import('./healing-hands.png')

		case "Healing Potion":
			return import('./healing-potion.png')

		case "Heavy Battleaxe":
			return import('./heavy-battleaxe.png')

		case "Heirloom Greatsword":
			return import('./heirloom-greatsword.png')

		case "Helgen Squad Leader":
			return import('./helgen-squad-leader.png')

		case "Helstrom Footpad":
			return import('./helstrom-footpad.png')

		case "Heretic Conjurer":
			return import('./heretic-conjurer.png')

		case "Hero of Anvil":
			return import('./hero-of-anvil.png')

		case "Heroic Rebirth":
			return import('./heroic-rebirth.png')

		case "Hidden Trail":
			return import('./hidden-trail.png')

		case "High Hrothgar":
			return import('./high-hrothgar.png')

		case "High King Emeric":
			return import('./high-king-emeric.png')

		case "High Rock Stalwart":
			return import('./high-rock-stalwart.png')

		case "High Rock Summoner":
			return import('./high-rock-summoner.png')

		case "Highland Lurcher":
			return import('./highland-lurcher.png')

		case "Hist Grove":
			return import('./hist-grove.png')

		case "Hist Speaker":
			return import('./hist-speaker.png')

		case "Hit and Run":
			return import('./hit-and-run.png')

		case "Hive Defender":
			return import('./hive-defender.png')

		case "Hive Warrior":
			return import('./hive-warrior.png')

		case "Hlaalu Oathman":
			return import('./hlaalu-oathman.png')

		case "Hlaalu Sharpshooter":
			return import('./hlaalu-sharpshooter.png')

		case "Horned Helm":
			return import('./horned-helm.png')

		case "Horse Armor":
			return import('./horse-armor.png')

		case "House Kinsman":
			return import('./house-kinsman.png')

		case "Hulking Fabricant":
			return import('./hulking-fabricant.png')

		case "Hulking Mummy":
			return import('./hulking-mummy.png')

		case "Hulking Scalon":
			return import('./hulking-scalon.png')

		case "Hunter-Killers":
			return import('./hunter-killers.png')

		case "Hush":
			return import('./hush.png')

		case "Ice Spike":
			return import('./ice-spike.png')

		case "Ice Storm":
			return import('./ice-storm.png')

		case "Ice Wraith":
			return import('./ice-wraith.png')

		case "Icewing Dragon":
			return import('./icewing-dragon.png')

		case "Icy Shambles":
			return import('./icy-shambles.png')

		case "Iliac Sorcerer":
			return import('./iliac-sorcerer.png')

		case "Ill-Fated Scholar":
			return import('./ill-fated-scholar.png')

		case "Illicit Butcher":
			return import('./illicit-butcher.png')

		case "Illusory Defenses":
			return import('./illusory-defenses.png')

		case "Illusory Mimic":
			return import('./illusory-mimic.png')

		case "Imbued Argonian":
			return import('./imbued-argonian.png')

		case "Imbued Bosmer":
			return import('./imbued-bosmer.png')

		case "Imbued Breton":
			return import('./imbued-breton.png')

		case "Imbued Khajiit":
			return import('./imbued-khajiit.png')

		case "Imbued Minotaur":
			return import('./imbued-minotaur.png')

		case "Immolating Blast":
			return import('./immolating-blast.png')

		case "Imperial Armor":
			return import('./imperial-armor.png')

		case "Imperial Camp":
			return import('./imperial-camp.png')

		case "Imperial Lackey":
			return import('./imperial-lackey.png')

		case "Imperial Legionnaire":
			return import('./imperial-legionnaire.png')

		case "Imperial Might":
			return import('./imperial-might.png')

		case "Imperial Reinforcements":
			return import('./imperial-reinforcements.png')

		case "Imperial Siege Engine":
			return import('./imperial-siege-engine.png')

		case "Imposter's Mission":
			return import('./imposter-s-mission.png')

		case "Imprison":
			return import('./imprison.png')

		case "Imprisoned Deathlord":
			return import('./imprisoned-deathlord.png')

		case "Improvised Weapon":
			return import('./improvised-weapon.png')

		case "Indomitable Ordinator":
			return import('./indomitable-ordinator.png')

		case "Indoril Archmage":
			return import('./indoril-archmage.png')

		case "Indoril Mastermind":
			return import('./indoril-mastermind.png')

		case "Innkeeper Delphine":
			return import('./innkeeper-delphine.png')

		case "Insightful Scholar":
			return import('./insightful-scholar.png')

		case "Inspiring Kinsman":
			return import('./inspiring-kinsman.png')

		case "Inspiring Soldier":
			return import('./inspiring-soldier.png')

		case "Inspiring Stormcloak":
			return import('./inspiring-stormcloak.png')

		case "Intimidate":
			return import('./intimidate.png')

		case "Invasion Marauder":
			return import('./invasion-marauder.png')

		case "Invasion Party":
			return import('./invasion-party.png')

		case "Invasion Scout":
			return import('./invasion-scout.png')

		case "Invasion Vanguard":
			return import('./invasion-vanguard.png')

		case "Invoker of the Hist":
			return import('./invoker-of-the-hist.png')

		case "Iron Atronach":
			return import('./iron-atronach.png')

		case "Ironscale Dragon":
			return import('./ironscale-dragon.png')

		case "J'zargo":
			return import('./j-zargo.png')

		case "Jarl Balgruuf":
			return import('./jarl-balgruuf.png')

		case "Jauffre":
			return import('./jauffre.png')

		case "Jerall Forager":
			return import('./jerall-forager.png')

		case "Jiub":
			return import('./jiub.png')

		case "Jorunn the Skald-King":
			return import('./jorunn-the-skald-king.png')

		case "Jorunn's Vanguard":
			return import('./jorunn-s-vanguard.png')

		case "Journey to Sovngarde":
			return import('./journey-to-sovngarde.png')

		case "Jyggalag's Incursion":
			return import('./jyggalag-s-incursion.png')

		case "Kaalgrontiid":
			return import('./kaalgrontiid.png')

		case "Kagouti Fabricant":
			return import('./kagouti-fabricant.png')

		case "Karthspire Scourge":
			return import('./karthspire-scourge.png')

		case "Karthspire Scout":
			return import('./karthspire-scout.png')

		case "Keeper of Whispers":
			return import('./keeper-of-whispers.png')

		case "Keeper of the Gates":
			return import('./keeper-of-the-gates.png')

		case "Khajiiti Warhelm":
			return import('./khajiiti-warhelm.png')

		case "Khamira":
			return import('./khamira.png')

		case "Khuul Lawkeeper":
			return import('./khuul-lawkeeper.png')

		case "Knife to the Throat":
			return import('./knife-to-the-throat.png')

		case "Knight of Gnisis":
			return import('./knight-of-gnisis.png')

		case "Knight of Order":
			return import('./knight-of-order.png')

		case "Knight of the Hour":
			return import('./knight-of-the-hour.png')

		case "Kvatch Soldier":
			return import('./kvatch-soldier.png')

		case "Kwama Queen":
			return import('./kwama-queen.png')

		case "Kynreeve Champion":
			return import('./kynreeve-champion.png')

		case "Laaneth":
			return import('./laaneth.png')

		case "Lady Syl's Cruelty":
			return import('./lady-syl-s-cruelty.png')

		case "Lame Corprus":
			return import('./lame-corprus.png')

		case "Lay Down Arms":
			return import('./lay-down-arms.png')

		case "Leaflurker":
			return import('./leaflurker.png')

		case "Leafwater Blessing":
			return import('./leafwater-blessing.png')

		case "Legate Rikke":
			return import('./legate-rikke.png')

		case "Legion Praefect":
			return import('./legion-praefect.png')

		case "Legion Shield":
			return import('./legion-shield.png')

		case "Legion Zero Templar":
			return import('./legion-zero-templar.png')

		case "Lesser Ward":
			return import('./lesser-ward.png')

		case "Lich's Ascension":
			return import('./lich-s-ascension.png')

		case "Light of the Three":
			return import('./light-of-the-three.png')

		case "Lightning Bolt":
			return import('./lightning-bolt.png')

		case "Lillandril Hexmage":
			return import('./lillandril-hexmage.png')

		case "Lion Guard Armaments":
			return import('./lion-guard-armaments.png')

		case "Lion Guard Strategist":
			return import('./lion-guard-strategist.png')

		case "Little Girl":
			return import('./little-girl.png')

		case "Lockpick":
			return import('./lockpick.png')

		case "Lord of the Arena":
			return import('./lord-of-the-arena.png')

		case "Lower Canton Smith":
			return import('./lower-canton-smith.png')

		case "Lowland Troll":
			return import('./lowland-troll.png')

		case "Loyal Housecarl":
			return import('./loyal-housecarl.png')

		case "Lucien Lachance":
			return import('./lucien-lachance.png')

		case "Lumbering Ogrim":
			return import('./lumbering-ogrim.png')

		case "Luminous Shards":
			return import('./luminous-shards.png')

		case "Lunar Sway":
			return import('./lunar-sway.png')

		case "Lurking Crocodile":
			return import('./lurking-crocodile.png')

		case "Lurking Mummy":
			return import('./lurking-mummy.png')

		case "Lute":
			return import('./lute.png')

		case "Luzrah gro-Shar":
			return import('./luzrah-gro-shar.png')

		case "Lydia":
			return import('./lydia.png')

		case "Lyris Titanborn":
			return import('./lyris-titanborn.png')

		case "Mace of Encumbrance":
			return import('./mace-of-encumbrance.png')

		case "Mad Dash":
			return import('./mad-dash.png')

		case "Madness Beckons":
			return import('./madness-beckons.png')

		case "Mage Slayer":
			return import('./mage-slayer.png')

		case "Mage's Trick":
			return import('./mage-s-trick.png')

		case "Mages Guild Conjurer":
			return import('./mages-guild-conjurer.png')

		case "Mages Guild Recruit":
			return import('./mages-guild-recruit.png')

		case "Mages Guild Retreat":
			return import('./mages-guild-retreat.png')

		case "Malefic Wreath":
			return import('./malefic-wreath.png')

		case "Manic Grummite/Demented Grummite":
			return import('./manic-grummite-demented-grummite.png')

		case "Manic Jack/Manic Mutation":
			return import('./manic-jack-manic-mutation.png')

		case "Mankar Camoran":
			return import('./mankar-camoran.png')

		case "Mannimarco":
			return import('./mannimarco.png')

		case "Mantikora":
			return import('./mantikora.png')

		case "Maple Shield":
			return import('./maple-shield.png')

		case "Marauder Chieftain":
			return import('./marauder-chieftain.png')

		case "Markarth Bannerman":
			return import('./markarth-bannerman.png')

		case "Marked Man":
			return import('./marked-man.png')

		case "Martin Septim":
			return import('./martin-septim.png')

		case "Master Swordsmith":
			return import('./master-swordsmith.png')

		case "Master of Arms":
			return import('./master-of-arms.png')

		case "Master of Incunabula":
			return import('./master-of-incunabula.png')

		case "Master of Thieves":
			return import('./master-of-thieves.png')

		case "Mausoleum Delver":
			return import('./mausoleum-delver.png')

		case "Mechanical Ally":
			return import('./mechanical-ally.png')

		case "Mecinar's Will":
			return import('./mecinar-s-will.png')

		case "Mecinar":
			return import('./mecinar.png')

		case "Mehrunes Dagon's Flayer":
			return import('./mehrunes-dagon-s-flayer.png')

		case "Mehrunes Dagon's Seducer":
			return import('./mehrunes-dagon-s-seducer.png')

		case "Memory Wraith":
			return import('./memory-wraith.png')

		case "Mentor of the Watch":
			return import('./mentor-of-the-watch.png')

		case "Mentor's Ring":
			return import('./mentor-s-ring.png')

		case "Mercenary Captain":
			return import('./mercenary-captain.png')

		case "Merchant's Camel":
			return import('./merchant-s-camel.png')

		case "Merric-at-Aswala":
			return import('./merric-at-aswala.png')

		case "Midnight Burial":
			return import('./midnight-burial.png')

		case "Midnight Snack":
			return import('./midnight-snack.png')

		case "Midnight Sweep":
			return import('./midnight-sweep.png')

		case "Midnight Trespasser":
			return import('./midnight-trespasser.png')

		case "Mighty Ally":
			return import('./mighty-ally.png')

		case "Mighty Conjuring":
			return import('./mighty-conjuring.png')

		case "Militant Chieftain":
			return import('./militant-chieftain.png')

		case "Miraak, Dragonborn":
			return import('./miraak-dragonborn.png')

		case "Miscarcand Lich":
			return import('./miscarcand-lich.png')

		case "Mistveil Enchanter":
			return import('./mistveil-enchanter.png')

		case "Mistveil Warden":
			return import('./mistveil-warden.png')

		case "Modryn Oreyn":
			return import('./modryn-oreyn.png')

		case "Moment of Clarity":
			return import('./moment-of-clarity.png')

		case "Monastic Champion":
			return import('./monastic-champion.png')

		case "Monster Perfection Lab":
			return import('./monster-perfection-lab.png')

		case "Monk's Strike":
			return import('./monk-s-strike.png')

		case "Moon Bishop":
			return import('./moon-bishop.png')

		case "Moon Gate":
			return import('./moon-gate.png')

		case "Moon Sugar Smuggler":
			return import('./moon-sugar-smuggler.png')

		case "Moonlight Werebat":
			return import('./moonlight-werebat.png')

		case "Moonmoth Castellan":
			return import('./moonmoth-castellan.png')

		case "Moonphase Suthay":
			return import('./moonphase-suthay.png')

		case "Moontouched Guardian":
			return import('./moontouched-guardian.png')

		case "Morag Tong Aspirant":
			return import('./morag-tong-aspirant.png')

		case "Morag Tong Assassin":
			return import('./morag-tong-assassin.png')

		case "Morag Tong Nightblade":
			return import('./morag-tong-nightblade.png')

		case "Morkul Gatekeeper":
			return import('./morkul-gatekeeper.png')

		case "Morokei, the Deathless":
			return import('./morokei-the-deathless.png')

		case "Morthal Executioner":
			return import('./morthal-executioner.png')

		case "Morthal Watchman":
			return import('./morthal-watchman.png')

		case "Mountain Lion":
			return import('./mountain-lion.png')

		case "Mountain Tyrant":
			return import('./mountain-tyrant.png')

		case "Mournhold Guardian":
			return import('./mournhold-guardian.png')

		case "Mournhold Pilgrim":
			return import('./mournhold-pilgrim.png')

		case "Mournhold Taskmaster":
			return import('./mournhold-taskmaster.png')

		case "Mournhold Traitor":
			return import('./mournhold-traitor.png')

		case "Move in Shadows":
			return import('./move-in-shadows.png')

		case "Mudcrab Anklesnapper":
			return import('./mudcrab-anklesnapper.png')

		case "Mudcrab Merchant":
			return import('./mudcrab-merchant.png')

		case "Mulaamnir":
			return import('./mulaamnir.png')

		case "Mummify":
			return import('./mummify.png')

		case "Mundus Stone":
			return import('./mundus-stone.png')

		case "Murkwater Butcher":
			return import('./murkwater-butcher.png')

		case "Murkwater Goblin":
			return import('./murkwater-goblin.png')

		case "Murkwater Guide":
			return import('./murkwater-guide.png')

		case "Murkwater Savage":
			return import('./murkwater-savage.png')

		case "Murkwater Scourge":
			return import('./murkwater-scourge.png')

		case "Murkwater Shaman":
			return import('./murkwater-shaman.png')

		case "Murkwater Skirmisher":
			return import('./murkwater-skirmisher.png')

		case "Murkwater Witch":
			return import('./murkwater-witch.png')

		case "Mushroom Tower":
			return import('./mushroom-tower.png')

		case "Mute":
			return import('./mute.png')

		case "Mystic Dragon":
			return import('./mystic-dragon.png')

		case "Mystic of Ancient Rites":
			return import('./mystic-of-ancient-rites.png')

		case "Mythic Dawn Acolyte":
			return import('./mythic-dawn-acolyte.png')

		case "Mythic Dawn Informer":
			return import('./mythic-dawn-informer.png')

		case "Mythic Dawn Zealot":
			return import('./mythic-dawn-zealot.png')

		case "Nahagliiv":
			return import('./nahagliiv.png')

		case "Nahkriin, Dragon Priest":
			return import('./nahkriin-dragon-priest.png')

		case "Namira's Shrine":
			return import('./namira-s-shrine.png')

		case "Naryu Virian":
			return import('./naryu-virian.png')

		case "Necrom Mastermind":
			return import('./necrom-mastermind.png')

		case "Necromancer's Amulet":
			return import('./necromancer-s-amulet.png')

		case "Nereid Sister":
			return import('./nereid-sister.png')

		case "Nervous Giant":
			return import('./nervous-giant.png')

		case "Nest of Vipers":
			return import('./nest-of-vipers.png')

		case "Niben Bay Cutthroat":
			return import('./niben-bay-cutthroat.png')

		case "Nibenese Mercenary":
			return import('./nibenese-mercenary.png')

		case "Night Predator":
			return import('./night-predator.png')

		case "Night Shadow":
			return import('./night-shadow.png')

		case "Night Talon Lord":
			return import('./night-talon-lord.png')

		case "Nightprowler":
			return import('./nightprowler.png')

		case "Nimble Ally":
			return import('./nimble-ally.png')

		case "Nix-Hound Fabricant":
			return import('./nix-hound-fabricant.png')

		case "Nix-Hound":
			return import('./nix-hound.png')

		case "Nix-Ox":
			return import('./nix-ox.png')

		case "Nord Firebrand":
			return import('./nord-firebrand.png')

		case "Northpoint Captain":
			return import('./northpoint-captain.png')

		case "Northwind Outpost":
			return import('./northwind-outpost.png')

		case "Oblivion Invasion":
			return import('./oblivion-invasion.png')

		case "Obstinate Goat":
			return import('./obstinate-goat.png')

		case "Occult Ritemaster":
			return import('./occult-ritemaster.png')

		case "Odahviing":
			return import('./odahviing.png')

		case "Odirniran Necromancer":
			return import('./odirniran-necromancer.png')

		case "Old Salty's Assault":
			return import('./old-salty-s-assault.png')

		case "Oldgate Warden":
			return import('./oldgate-warden.png')

		case "Orb of Vaermina":
			return import('./orb-of-vaermina.png')

		case "Orc Clan Captain":
			return import('./orc-clan-captain.png')

		case "Orc Clan Shaman":
			return import('./orc-clan-shaman.png')

		case "Orcish Warhammer":
			return import('./orcish-warhammer.png')

		case "Ordinator of the Almsivi":
			return import('./ordinator-of-the-almsivi.png')

		case "Ornamented Sword":
			return import('./ornamented-sword.png')

		case "Ornery Kagouti":
			return import('./ornery-kagouti.png')

		case "Orsinium Forge":
			return import('./orsinium-forge.png')

		case "Orvas' Bargain":
			return import('./orvas-bargain.png')

		case "Outflank":
			return import('./outflank.png')

		case "Outland Patrol":
			return import('./outland-patrol.png')

		case "Paarthurnax":
			return import('./paarthurnax.png')

		case "Pack Leader":
			return import('./pack-leader.png')

		case "Pack Wolf":
			return import('./pack-wolf.png')

		case "Pact Oathman":
			return import('./pact-oathman.png')

		case "Pact Outcast":
			return import('./pact-outcast.png')

		case "Pact Shieldbearer":
			return import('./pact-shieldbearer.png')

		case "Pahmar-raht Renegade":
			return import('./pahmar-raht-renegade.png')

		case "Painted World":
			return import('./painted-world.png')

		case "Palace Conspirator":
			return import('./palace-conspirator.png')

		case "Palace Prowler":
			return import('./palace-prowler.png')

		case "Paralyze":
			return import('./paralyze.png')

		case "Penitus Oculatus Agent":
			return import('./penitus-oculatus-agent.png')

		case "Phalanx Exemplar":
			return import('./phalanx-exemplar.png')

		case "Piercing Javelin":
			return import('./piercing-javelin.png')

		case "Piercing Twilight":
			return import('./piercing-twilight.png')

		case "Pillaging Tribune":
			return import('./pillaging-tribune.png')

		case "Pit Lion":
			return import('./pit-lion.png')

		case "Plea to Kynareth":
			return import('./plea-to-kynareth.png')

		case "Plunder":
			return import('./plunder.png')

		case "Poetic Armiger":
			return import('./poetic-armiger.png')

		case "Pointy Wall of Spikes":
			return import('./pointy-wall-of-spikes.png')

		case "Poisoned Dagger":
			return import('./poisoned-dagger.png')

		case "Portcullis":
			return import('./portcullis.png')

		case "Pouncing Senche":
			return import('./pouncing-senche.png')

		case "Power of the Almsivi":
			return import('./power-of-the-almsivi.png')

		case "Praetorian Commander":
			return import('./praetorian-commander.png')

		case "Prankster Mage":
			return import('./prankster-mage.png')

		case "Preserver of the Root":
			return import('./preserver-of-the-root.png')

		case "Preying Elytra":
			return import('./preying-elytra.png')

		case "Priest of Mara":
			return import('./priest-of-mara.png')

		case "Priest of the Eight":
			return import('./priest-of-the-eight.png')

		case "Priest of the Moons":
			return import('./priest-of-the-moons.png')

		case "Prison Ship":
			return import('./prison-ship.png')

		case "Prized Chicken":
			return import('./prized-chicken.png')

		case "Prophet of Bones":
			return import('./prophet-of-bones.png')

		case "Protector of the Innocent":
			return import('./protector-of-the-innocent.png')

		case "Protector of the Mane":
			return import('./protector-of-the-mane.png')

		case "Prowl Smuggler":
			return import('./prowl-smuggler.png')

		case "Pure-Blood Elder":
			return import('./pure-blood-elder.png')

		case "Quarra Clan Bloodkin":
			return import('./quarra-clan-bloodkin.png')

		case "Queen Barenziah":
			return import('./queen-barenziah.png')

		case "Queen's Captain":
			return import('./queen-s-captain.png')

		case "Quicksilver Crossbow":
			return import('./quicksilver-crossbow.png')

		case "Quin'rawl Burglar":
			return import('./quin-rawl-burglar.png')

		case "Raging Horker":
			return import('./raging-horker.png')

		case "Raiding Party":
			return import('./raiding-party.png')

		case "Rajhini Highwayman":
			return import('./rajhini-highwayman.png')

		case "Rampaging Minotaur":
			return import('./rampaging-minotaur.png')

		case "Ransack":
			return import('./ransack.png')

		case "Rapid Shot":
			return import('./rapid-shot.png')

		case "Ratway Prospector":
			return import('./ratway-prospector.png')

		case "Ravaging Elixir":
			return import('./ravaging-elixir.png')

		case "Ravenous Crocodile":
			return import('./ravenous-crocodile.png')

		case "Ravenous Hunger":
			return import('./ravenous-hunger.png')

		case "Razum-Dar":
			return import('./razum-dar.png')

		case "Reachman Shaman":
			return import('./reachman-shaman.png')

		case "Reanimate":
			return import('./reanimate.png')

		case "Rebel Warden":
			return import('./rebel-warden.png')

		case "Rebellion General":
			return import('./rebellion-general.png')

		case "Reconstruction Engine":
			return import('./reconstruction-engine.png')

		case "Red Bramman":
			return import('./red-bramman.png')

		case "Red Mountain":
			return import('./red-mountain.png')

		case "Redoran Battlespear":
			return import('./redoran-battlespear.png')

		case "Redoran Enforcer":
			return import('./redoran-enforcer.png')

		case "Redoran Forerunner":
			return import('./redoran-forerunner.png')

		case "Redoran Oathman":
			return import('./redoran-oathman.png')

		case "Reflective Automaton":
			return import('./reflective-automaton.png')

		case "Reive, Blademaster":
			return import('./reive-blademaster.png')

		case "Relentless Raider":
			return import('./relentless-raider.png')

		case "Relic Hunter":
			return import('./relic-hunter.png')

		case "Renegade Magister":
			return import('./renegade-magister.png')

		case "Renowned Instructor":
			return import('./renowned-instructor.png')

		case "Renowned Legate":
			return import('./renowned-legate.png')

		case "Resolute Ally":
			return import('./resolute-ally.png')

		case "Restless Templar":
			return import('./restless-templar.png')

		case "Restoration Tutor":
			return import('./restoration-tutor.png')

		case "Revealing the Unseen":
			return import('./revealing-the-unseen.png')

		case "Reverberating Strike":
			return import('./reverberating-strike.png')

		case "Revered Guardian":
			return import('./revered-guardian.png')

		case "Rift Thane":
			return import('./rift-thane.png')

		case "Riften Lawkeeper":
			return import('./riften-lawkeeper.png')

		case "Riften Pickpocket":
			return import('./riften-pickpocket.png')

		case "Riften Pillager":
			return import('./riften-pillager.png')

		case "Rihad Battlemage":
			return import('./rihad-battlemage.png')

		case "Rihad Horseman":
			return import('./rihad-horseman.png')

		case "Rimmen Purveyor":
			return import('./rimmen-purveyor.png')

		case "Rimmen Siege Weapons":
			return import('./rimmen-siege-weapons.png')

		case "Ring of Imaginary Might":
			return import('./ring-of-imaginary-might.png')

		case "Ring of Lordship":
			return import('./ring-of-lordship.png')

		case "Ring of Namira":
			return import('./ring-of-namira.png')

		case "Rising of Bones":
			return import('./rising-of-bones.png')

		case "Riverhold Escort":
			return import('./riverhold-escort.png')

		case "Royal Sage":
			return import('./royal-sage.png')

		case "Ruin Archaeologist":
			return import('./ruin-archaeologist.png')

		case "Ruin Shambler":
			return import('./ruin-shambler.png')

		case "Ruthless Freebooter":
			return import('./ruthless-freebooter.png')

		case "Sadras Agent":
			return import('./sadras-agent.png')

		case "Sai Sahan":
			return import('./sai-sahan.png')

		case "Sails-Through-Storms":
			return import('./sails-through-storms.png')

		case "Salvage":
			return import('./salvage.png')

		case "Sanctuary Pet":
			return import('./sanctuary-pet.png')

		case "Sanctuary Raid":
			return import('./sanctuary-raid.png')

		case "Sarethi Scion":
			return import('./sarethi-scion.png')

		case "Savage Ogre":
			return import('./savage-ogre.png')

		case "Scout's Report":
			return import('./scout-s-report.png')

		case "Scouting Patrol":
			return import('./scouting-patrol.png')

		case "Scroll Seeker":
			return import('./scroll-seeker.png')

		case "Scuttler":
			return import('./scuttler.png')

		case "Seasoned Captain":
			return import('./seasoned-captain.png')

		case "Seducer Darkfire":
			return import('./seducer-darkfire.png')

		case "Seeker of the Black Arts":
			return import('./seeker-of-the-black-arts.png')

		case "Seething Flesh Golem":
			return import('./seething-flesh-golem.png')

		case "Seht's Masterwork":
			return import('./seht-s-masterwork.png')

		case "Senche-raht Graveprowler":
			return import('./senche-raht-graveprowler.png')

		case "Senche Noble":
			return import('./senche-noble.png')

		case "Senche-Tiger":
			return import('./senche-tiger.png')

		case "Sentinel Battlemace":
			return import('./sentinel-battlemace.png')

		case "Sentinel Reclaimer":
			return import('./sentinel-reclaimer.png')

		case "Septim Guardsman":
			return import('./septim-guardsman.png')

		case "Serpentine Stalker":
			return import('./serpentine-stalker.png')

		case "Servant of Dagoth":
			return import('./servant-of-dagoth.png')

		case "Servant of Ja-Kha'jay":
			return import('./servant-of-ja-kha-jay.png')

		case "Seyda Neen Courier":
			return import('./seyda-neen-courier.png')

		case "Shadow Shift":
			return import('./shadow-shift.png')

		case "Shadowfen Priest":
			return import('./shadowfen-priest.png')

		case "Shadowgreen Elder":
			return import('./shadowgreen-elder.png')

		case "Shadowmarking":
			return import('./shadowmarking.png')

		case "Shadowmaster":
			return import('./shadowmaster.png')

		case "Shadowmere":
			return import('./shadowmere.png')

		case "Shadowscale Hunter":
			return import('./shadowscale-hunter.png')

		case "Shadowscale Partisan":
			return import('./shadowscale-partisan.png')

		case "Shalk Fabricant":
			return import('./shalk-fabricant.png')

		case "Sharp-Eyed Ashkhan":
			return import('./sharp-eyed-ashkhan.png')

		case "Sharpshooter Scout":
			return import('./sharpshooter-scout.png')

		case "Shearpoint Dragon":
			return import('./shearpoint-dragon.png')

		case "Shield Breaker":
			return import('./shield-breaker.png')

		case "Shimmerene Peddler":
			return import('./shimmerene-peddler.png')

		case "Shining Saint":
			return import('./shining-saint.png')

		case "Shivering Apothecary":
			return import('./shivering-apothecary.png')

		case "Shocking Wamasu":
			return import('./shocking-wamasu.png')

		case "Shornhelm Champion":
			return import('./shornhelm-champion.png')

		case "Shrewd Strategist":
			return import('./shrewd-strategist.png')

		case "Shrieking Harpy":
			return import('./shrieking-harpy.png')

		case "Shrine Guardian":
			return import('./shrine-guardian.png')

		case "Siege Catapult":
			return import('./siege-catapult.png')

		case "Siege Crawler":
			return import('./siege-crawler.png')

		case "Siege of Stros M'Kai":
			return import('./siege-of-stros-m-kai.png')

		case "Sightless Skulk":
			return import('./sightless-skulk.png')

		case "Sigil Keeper":
			return import('./sigil-keeper.png')

		case "Silent Pilgrim":
			return import('./silent-pilgrim.png')

		case "Silt Strider":
			return import('./silt-strider.png')

		case "Silvenar Tracker":
			return import('./silvenar-tracker.png')

		case "Sixth House Amulet":
			return import('./sixth-house-amulet.png')

		case "Skar Drillmaster":
			return import('./skar-drillmaster.png')

		case "Skaven Pyromancer":
			return import('./skaven-pyromancer.png')

		case "Skeevaton":
			return import('./skeevaton.png')

		case "Skeever Infestation":
			return import('./skeever-infestation.png')

		case "Skeletal Dragon":
			return import('./skeletal-dragon.png')

		case "Skeletal Mage":
			return import('./skeletal-mage.png')

		case "Skeleton Champion":
			return import('./skeleton-champion.png')

		case "Skilled Blacksmith":
			return import('./skilled-blacksmith.png')

		case "Skingrad Patroller":
			return import('./skingrad-patroller.png')

		case "Skinned Hound":
			return import('./skinned-hound.png')

		case "Skirmisher's Elixir":
			return import('./skirmisher-s-elixir.png')

		case "Skooma Cat's Whimsy":
			return import('./skooma-cat-s-whimsy.png')

		case "Skooma Racketeer":
			return import('./skooma-racketeer.png')

		case "Skooma Underboss":
			return import('./skooma-underboss.png')

		case "Skyborn Dragon":
			return import('./skyborn-dragon.png')

		case "Skyforge":
			return import('./skyforge.png')

		case "Skyshard":
			return import('./skyshard.png')

		case "Skywatch Vindicator":
			return import('./skywatch-vindicator.png')

		case "Slaughterfish Spawning":
			return import('./slaughterfish-spawning.png')

		case "Slinking Jackal":
			return import('./slinking-jackal.png')

		case "Sly Marshblade":
			return import('./sly-marshblade.png')

		case "Smash and Grab":
			return import('./smash-and-grab.png')

		case "Smuggler Underboss":
			return import('./smuggler-underboss.png')

		case "Smuggler's Haul":
			return import('./smuggler-s-haul.png')

		case "Snake Tooth Necklace":
			return import('./snake-tooth-necklace.png')

		case "Snow Wolf":
			return import('./snow-wolf.png')

		case "Snowhawk detachment":
			return import('./snowhawk-detachment.png')

		case "Snowy Sabre Cat":
			return import('./snowy-sabre-cat.png')

		case "Solitude Stalwart":
			return import('./solitude-stalwart.png')

		case "Sorcerer's Negation":
			return import('./sorcerer-s-negation.png')

		case "Sotha Sil":
			return import('./sotha-sil.png')

		case "Soul Shred":
			return import('./soul-shred.png')

		case "Soul Split":
			return import('./soul-split.png')

		case "Soul Tear":
			return import('./soul-tear.png')

		case "Soul Wraith":
			return import('./soul-wraith.png')

		case "Soulburst":
			return import('./soulburst.png')

		case "Soulrest Marshal":
			return import('./soulrest-marshal.png')

		case "Sound the Alarm":
			return import('./sound-the-alarm.png')

		case "Sower of Revenge":
			return import('./sower-of-revenge.png')

		case "Sparking Spider":
			return import('./sparking-spider.png')

		case "Sparksmith":
			return import('./sparksmith.png')

		case "Spawn Mother/Baliwog":
			return import('./spawn-mother-baliwog.png')

		case "Speaker Terenus":
			return import('./speaker-terenus.png')

		case "Spear of Embers":
			return import('./spear-of-embers.png')

		case "Spellsword's Summoning":
			return import('./spellsword-s-summoning.png')

		case "Spider Daedra":
			return import('./spider-daedra.png')

		case "Spider Lair":
			return import('./spider-lair.png')

		case "Spider Worker":
			return import('./spider-worker.png')

		case "Spine of Eldersblood":
			return import('./spine-of-eldersblood.png')

		case "Spiny Haj Mota":
			return import('./spiny-haj-mota.png')

		case "Spirit Knife":
			return import('./spirit-knife.png')

		case "Spiteful Dremora":
			return import('./spiteful-dremora.png')

		case "Spoils of War":
			return import('./spoils-of-war.png')

		case "Squish the Wimpy":
			return import('./squish-the-wimpy.png')

		case "Staff of Ice":
			return import('./staff-of-ice.png')

		case "Staff of Sparks":
			return import('./staff-of-sparks.png')

		case "Stalking Shadowscale":
			return import('./stalking-shadowscale.png')

		case "Stalwart Ally":
			return import('./stalwart-ally.png')

		case "Stampede Sentinel":
			return import('./stampede-sentinel.png')

		case "Stampeding Mammoth":
			return import('./stampeding-mammoth.png')

		case "Stand Watch":
			return import('./stand-watch.png')

		case "Star-Sung Bard":
			return import('./star-sung-bard.png')

		case "Stealer of Secrets":
			return import('./stealer-of-secrets.png')

		case "Steam Constructor":
			return import('./steam-constructor.png')

		case "Steel Scimitar":
			return import('./steel-scimitar.png')

		case "Steel Sword":
			return import('./steel-sword.png')

		case "Steel-Eyed Visionary":
			return import('./steel-eyed-visionary.png')

		case "Steelheart Vanquisher":
			return import('./steelheart-vanquisher.png')

		case "Stendarr's Hammer":
			return import('./stendarr-s-hammer.png')

		case "Stolen Pants":
			return import('./stolen-pants.png')

		case "Stone Throw":
			return import('./stone-throw.png')

		case "Stonehill Mammoth":
			return import('./stonehill-mammoth.png')

		case "Stoneshard Orc":
			return import('./stoneshard-orc.png')

		case "Stonetooth Scrapper":
			return import('./stonetooth-scrapper.png')

		case "Stormcloak Avenger":
			return import('./stormcloak-avenger.png')

		case "Stormcloak Camp":
			return import('./stormcloak-camp.png')

		case "Stormcloak Vanguard":
			return import('./stormcloak-vanguard.png')

		case "Stormhold Henchman":
			return import('./stormhold-henchman.png')

		case "Stoutheart Giant":
			return import('./stoutheart-giant.png')

		case "Strange Brew":
			return import('./strange-brew.png')

		case "Strategic Deployment":
			return import('./strategic-deployment.png')

		case "Strategist's Map":
			return import('./strategist-s-map.png')

		case "Stronghold Eradicator":
			return import('./stronghold-eradicator.png')

		case "Stronghold Incubator":
			return import('./stronghold-incubator.png')

		case "Stronghold Patrol":
			return import('./stronghold-patrol.png')

		case "Studious Greybeard":
			return import('./studious-greybeard.png')

		case "Studium Headmaster":
			return import('./studium-headmaster.png')

		case "Summerset Orrery":
			return import('./summerset-orrery.png')

		case "Summerset Shieldmage":
			return import('./summerset-shieldmage.png')

		case "Sun-in-Shadow":
			return import('./sun-in-shadow.png')

		case "Sunhold Medic":
			return import('./sunhold-medic.png')

		case "Sunken One":
			return import('./sunken-one.png')

		case "Supply Runner":
			return import('./supply-runner.png')

		case "Suppress":
			return import('./suppress.png')

		case "Supreme Atromancer":
			return import('./supreme-atromancer.png')

		case "Supreme Dragon":
			return import('./supreme-dragon.png')

		case "Suran Pawnbroker":
			return import('./suran-pawnbroker.png')

		case "Suthay Bootlegger":
			return import('./suthay-bootlegger.png')

		case "Swamp Leviathan":
			return import('./swamp-leviathan.png')

		case "Swift Strike":
			return import('./swift-strike.png')

		case "Swiftwing Dragon":
			return import('./swiftwing-dragon.png')

		case "Swims-at-Night":
			return import('./swims-at-night.png')

		case "Swindler's Market":
			return import('./swindler-s-market.png')

		case "Sword of the Inferno":
			return import('./sword-of-the-inferno.png')

		case "Syl, Duchess of Dementia":
			return import('./syl-duchess-of-dementia.png')

		case "Tavyar the Knight/Rayvat the Mage":
			return import('./tavyar-the-knight-rayvat-the-mage.png')

		case "Tazkad the Packmaster":
			return import('./tazkad-the-packmaster.png')

		case "Tel Vos Magister":
			return import('./tel-vos-magister.png')

		case "Telekinesis":
			return import('./telekinesis.png')

		case "Telvanni Arcanist":
			return import('./telvanni-arcanist.png')

		case "Telvanni Catspaw":
			return import('./telvanni-catspaw.png')

		case "Telvanni Oathman":
			return import('./telvanni-oathman.png')

		case "Temple Conjurer":
			return import('./temple-conjurer.png')

		case "Temple Patriarch":
			return import('./temple-patriarch.png')

		case "Tenarr Zalviit Lurker":
			return import('./tenarr-zalviit-lurker.png')

		case "Tenarr Zalviit Nightstalker":
			return import('./tenarr-zalviit-nightstalker.png')

		case "Tenmar Swiftclaw":
			return import('./tenmar-swiftclaw.png')

		case "Territorial Viper":
			return import('./territorial-viper.png')

		case "Thadon, Duke of Mania":
			return import('./thadon-duke-of-mania.png')

		case "Thalmor Embassy":
			return import('./thalmor-embassy.png')

		case "Thalmor Justiciar":
			return import('./thalmor-justiciar.png')

		case "The Black Dragon":
			return import('./the-black-dragon.png')

		case "The Crisis Begins":
			return import('./the-crisis-begins.png')

		case "The Gatekeeper":
			return import('./the-gatekeeper.png')

		case "The Gray Fox":
			return import('./the-gray-fox.png')

		case "The Mechanical Heart":
			return import('./the-mechanical-heart.png')

		case "The Night Mother":
			return import('./the-night-mother.png')

		case "The Red Year":
			return import('./the-red-year.png')

		case "The Ruby Throne":
			return import('./the-ruby-throne.png')

		case "The Ultimate Heist":
			return import('./the-ultimate-heist.png')

		case "Therana's Lawman":
			return import('./therana-s-lawman.png')

		case "Therana":
			return import('./therana.png')

		case "Thief of Dreams":
			return import('./thief-of-dreams.png')

		case "Thievery":
			return import('./thievery.png')

		case "Thieves Guild Fence":
			return import('./thieves-guild-fence.png')

		case "Thieves Guild Recruit":
			return import('./thieves-guild-recruit.png')

		case "Thieves Guild Shadowfoot":
			return import('./thieves-guild-shadowfoot.png')

		case "Thieves' Den":
			return import('./thieves-den.png')

		case "Thorn Histmage":
			return import('./thorn-histmage.png')

		case "Thornwell Terror":
			return import('./thornwell-terror.png')

		case "Three Feather Warchief":
			return import('./three-feather-warchief.png')

		case "Throne Aligned":
			return import('./throne-aligned.png')

		case "Tiny Dragon":
			return import('./tiny-dragon.png')

		case "Tome of Alteration":
			return import('./tome-of-alteration.png')

		case "Torval Crook":
			return import('./torval-crook.png')

		case "Torval Extortionist":
			return import('./torval-extortionist.png')

		case "Tower Alchemist":
			return import('./tower-alchemist.png')

		case "Training Grounds":
			return import('./training-grounds.png')

		case "Traitor's Flames":
			return import('./traitor-s-flames.png')

		case "Transitus Shrine":
			return import('./transitus-shrine.png')

		case "Transmogrify":
			return import('./transmogrify.png')

		case "Treasure Map":
			return import('./treasure-map.png')

		case "Trebuchet":
			return import('./trebuchet.png')

		case "Tree Minder":
			return import('./tree-minder.png')

		case "Trespasser's Bane":
			return import('./trespasser-s-bane.png')

		case "Trial of Flame":
			return import('./trial-of-flame.png')

		case "Tribunal Oathman":
			return import('./tribunal-oathman.png')

		case "Triumphant Jarl":
			return import('./triumphant-jarl.png')

		case "Trouble Seeker":
			return import('./trouble-seeker.png')

		case "Trusty Sword":
			return import('./trusty-sword.png')

		case "Tullius' Conscription":
			return import('./tullius-conscription.png')

		case "Tusked Bristleback":
			return import('./tusked-bristleback.png')

		case "Twin Lamps Consul":
			return import('./twin-lamps-consul.png')

		case "Two-Moons Contemplation":
			return import('./two-moons-contemplation.png')

		case "Tyr":
			return import('./tyr.png')

		case "Ulfric Stormcloak":
			return import('./ulfric-stormcloak.png')

		case "Ulfric's Housecarl":
			return import('./ulfric-s-housecarl.png')

		case "Ulfric's Uprising":
			return import('./ulfric-s-uprising.png')

		case "Ulfric's Zealot":
			return import('./ulfric-s-zealot.png')

		case "Umaril the Unfeathered":
			return import('./umaril-the-unfeathered.png')

		case "Umbra":
			return import('./umbra.png')

		case "Underworld Vigilante":
			return import('./underworld-vigilante.png')

		case "Undying Dragon":
			return import('./undying-dragon.png')

		case "Unexpected Arrival":
			return import('./unexpected-arrival.png')

		case "Unfinished Business":
			return import('./unfinished-business.png')

		case "Ungolim the Listener":
			return import('./ungolim-the-listener.png')

		case "Unicorn":
			return import('./unicorn.png')

		case "Unite the Houses":
			return import('./unite-the-houses.png')

		case "Unrelenting Force":
			return import('./unrelenting-force.png')

		case "Unrelenting Siege":
			return import('./unrelenting-siege.png')

		case "Unstable Madman":
			return import('./unstable-madman.png')

		case "Unstoppable Rage":
			return import('./unstoppable-rage.png')

		case "Valenwood Huntsman":
			return import('./valenwood-huntsman.png')

		case "Valenwood Sentry":
			return import('./valenwood-sentry.png')

		case "Valkynaz Mage":
			return import('./valkynaz-mage.png')

		case "Vanus Galerion":
			return import('./vanus-galerion.png')

		case "Vanus's Scribe":
			return import('./vanus-s-scribe.png')

		case "Varanis Courier":
			return import('./varanis-courier.png')

		case "Varen Aquilarios":
			return import('./varen-aquilarios.png')

		case "Vastarie":
			return import('./vastarie.png')

		case "Verminous Fabricant":
			return import('./verminous-fabricant.png')

		case "Vicious Dreugh":
			return import('./vicious-dreugh.png')

		case "Vigilant Ancestor":
			return import('./vigilant-ancestor.png')

		case "Vigilant Giant":
			return import('./vigilant-giant.png')

		case "Vigilant of Stendarr":
			return import('./vigilant-of-stendarr.png')

		case "Vivec City Pilgrim":
			return import('./vivec-city-pilgrim.png')

		case "Vivec":
			return import('./vivec.png')

		case "Voice of Balance":
			return import('./voice-of-balance.png')

		case "Volendrung":
			return import('./volendrung.png')

		case "Voracious Spriggan":
			return import('./voracious-spriggan.png')

		case "Vvardvark Experiment":
			return import('./vvardvark-experiment.png')

		case "Wabbajack":
			return import('./wabbajack.png')

		case "Wake the Dead":
			return import('./wake-the-dead.png')

		case "Wandering Skeleton":
			return import('./wandering-skeleton.png')

		case "War Cry":
			return import('./war-cry.png')

		case "War-Hardened Senche":
			return import('./war-hardened-senche.png')

		case "Warclaw Mercenary":
			return import('./warclaw-mercenary.png')

		case "Wardcrafter":
			return import('./wardcrafter.png')

		case "Warrior's Fury":
			return import('./warrior-s-fury.png')

		case "Watch Commander":
			return import('./watch-commander.png')

		case "Waves of the Fallen":
			return import('./waves-of-the-fallen.png')

		case "Weakness":
			return import('./weakness.png')

		case "Whirling Duelist":
			return import('./whirling-duelist.png')

		case "Whispering Claw Strike":
			return import('./whispering-claw-strike.png')

		case "Whiterun Protector":
			return import('./whiterun-protector.png')

		case "Whiterun Trooper":
			return import('./whiterun-trooper.png')

		case "Whodunit?":
			return import('./whodunit-.png')

		case "Widow Daedra":
			return import('./widow-daedra.png')

		case "Wild Beastcaller":
			return import('./wild-beastcaller.png')

		case "Wild Boar":
			return import('./wild-boar.png')

		case "Wild Clumsiness":
			return import('./wild-clumsiness.png')

		case "Wild Echatere":
			return import('./wild-echatere.png')

		case "Wildfire Dragon":
			return import('./wildfire-dragon.png')

		case "Wilds Incarnate":
			return import('./wilds-incarnate.png')

		case "Will-o-the-Wisp":
			return import('./will-o-the-wisp.png')

		case "Wily Kee'va":
			return import('./wily-kee-va.png')

		case "Wind Keep Spellsword":
			return import('./wind-keep-spellsword.png')

		case "Windhelm Gatekeeper":
			return import('./windhelm-gatekeeper.png')

		case "Winter's Grasp":
			return import('./winter-s-grasp.png')

		case "Winterhold Illusionist":
			return import('./winterhold-illusionist.png')

		case "Wisdom of Ancients":
			return import('./wisdom-of-ancients.png')

		case "Wish":
			return import('./wish.png')

		case "Wispmother":
			return import('./wispmother.png')

		case "Withered Hand Cultist":
			return import('./withered-hand-cultist.png')

		case "Wolf Cage":
			return import('./wolf-cage.png')

		case "Wood Orc Headhunter":
			return import('./wood-orc-headhunter.png')

		case "Woodland Lookout":
			return import('./woodland-lookout.png')

		case "Word Wall":
			return import('./word-wall.png')

		case "World-Eater's Eyrie":
			return import('./world-eater-s-eyrie.png')

		case "Worldly Wanderer":
			return import('./worldly-wanderer.png')

		case "Worm King's Agent":
			return import('./worm-king-s-agent.png')

		case "Wrath of Sithis":
			return import('./wrath-of-sithis.png')

		case "Writ of Execution":
			return import('./writ-of-execution.png')

		case "Wrothgar Artisan":
			return import('./wrothgar-artisan.png')

		case "Wrothgar Forge":
			return import('./wrothgar-forge.png')

		case "Wrothgar Kingpin":
			return import('./wrothgar-kingpin.png')

		case "Xavara Atronach":
			return import('./xavara-atronach.png')

		case "Xivilai Warlord":
			return import('./xivilai-warlord.png')

		case "Xivkyn Banelord":
			return import('./xivkyn-banelord.png')

		case "Yagrum Bagarn":
			return import('./yagrum-bagarn.png')

		case "Yagrum's Workshop":
			return import('./yagrum-s-workshop.png')

		case "Yew Shield":
			return import('./yew-shield.png')

		case "Yokudan Nightblade":
			return import('./yokudan-nightblade.png')

		case "Young Dragonborn":
			return import('./young-dragonborn.png')

		case "Young Mammoth":
			return import('./young-mammoth.png')

		case "Zumog Phoom":
			return import('./zumog-phoom.png')

    default:
      return import('./reflective-automaton.png')
	}
}